<template>
  <h3
    v-if="value.title && subtitle"
    :class="
      (value.paragraph || Array.isArray(value.paragraphs) ? 'mb-3' : '') +
      ' ' +
      (titleCenter ? 'text-center' : '')
    "
    class="text-h5"
  >
    <StyledText :em-class="emClassTitle" :value="value.title" />
  </h3>
  <h2
    v-else-if="value.title"
    :class="
      (value.paragraph || Array.isArray(value.paragraphs) ? 'mb-4' : '') +
      ' ' +
      (titleCenter ? 'text-center' : '')
    "
    class="text-h5 text-sm-h4"
  >
    <StyledText :em-class="emClassTitle" :value="value.title" />
  </h2>

  <template v-if="Array.isArray(value.paragraphs)">
    <p v-for="(p, i) in value.paragraphs" :key="i" class="text-body-0 mb-2">
      <StyledText :em-class="emClassParagraph" :value="p" />
    </p>
  </template>

  <p v-else-if="value.paragraph" class="text-body-0">
    <StyledText :em-class="emClassParagraph" :value="value.paragraph" />
  </p>
</template>

<script setup>
defineProps({
  emClassParagraph: {
    default: undefined,
    type: String
  },
  emClassTitle: {
    default: undefined,
    type: String
  },
  subtitle: {
    default: false,
    type: Boolean
  },
  titleCenter: {
    default: false,
    type: Boolean
  },
  value: {
    required: true,
    type: Object
  }
})
</script>
